module.exports = __webpack_public_path__ + "media/images/eedn-logo-6698f7fe14166975e967b96d6b3fcb45.png";